import type { GTableBoxBorderBase, GTableBoxPaddingBase } from '~/presentation/ui';

import { useGTableContext } from '~/presentation/ui';
import { BlockStack, Box } from '@shopify/polaris';

export const Cell = ({
  children,
  index,
  padding,
  borders,
}: {
  children: React.ReactNode;
  index: number;
  padding?: GTableBoxPaddingBase;
  borders?: GTableBoxBorderBase;
}) => {
  const { alignments, getHighlightBgColumn } = useGTableContext();

  const assignment = alignments[index] ?? 'start';
  const highlightBg = getHighlightBgColumn(index);

  return (
    <div className={`Polaris-GTable-Cell`}>
      <Box {...padding} {...borders} {...highlightBg} width="100%" minHeight="100%">
        {/* <div className="Polaris-GTable-Cell"> */}
        <BlockStack inlineAlign={assignment} align="center">
          {children}
        </BlockStack>
        {/* </div> */}
      </Box>
    </div>
  );
};
